import React from 'react';
import { Lock } from 'lucide-react';

interface LockedToolCardProps {
  index: number;
}

export function LockedToolCard({ index }: LockedToolCardProps) {
  return (
    <div className="relative bg-gray-50 border border-gray-200 rounded-xl overflow-hidden">
      <div className="p-5 sm:p-6">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-lg bg-gray-200 flex items-center justify-center">
            <Lock className="w-5 h-5 text-gray-400" />
          </div>
          <div className="flex-1">
            <div className="h-5 w-32 bg-gray-200 rounded mb-2" />
            <div className="h-4 w-24 bg-gray-100 rounded" />
          </div>
          <div className="flex items-center gap-2">
            <Lock className="w-4 h-4 text-gray-400" />
            <span className="text-sm text-gray-400 font-medium">Tool #{index}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
